import React from "react";

const CustomArrowLeft = () => (
  <svg
    width="35"
    height="78"
    viewBox="0 0 35 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.339 4L5.97803 37.628L28.339 73.094"
      stroke="#0C0C0C"
      stroke-miterlimit="10"
    />
  </svg>
);

export default CustomArrowLeft;
